import inViewport from '@resources/js/helpers/inViewport.js';


inViewport(document.querySelector('.js-hotel-reviews-item'), async () => {
	const { default: fillProgressBar } = await import('@resources/js/fillProgressBar');
    fillProgressBar();
});

